var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
var WarningBox = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: #e8e8e8;\n  color: #ff9800;\n  border-radius: 3px 3px;\n  padding: 12px;\n  font-size: 1rem;\n"], ["\n  background-color: #e8e8e8;\n  color: #ff9800;\n  border-radius: 3px 3px;\n  padding: 12px;\n  font-size: 1rem;\n"])));
var Content = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: 10px;\n  color: black;\n"], ["\n  margin-left: 10px;\n  color: black;\n"])));
var Notification = function (_a) {
  var children = _a.children,
    style = _a.style;
  switch (style) {
    case "warning":
    default:
      return React.createElement(WarningBox, null, React.createElement(FontAwesomeIcon, {
        icon: faExclamationTriangle
      }), React.createElement(Content, null, children));
  }
};
export default Notification;
var templateObject_1, templateObject_2;